var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTwitter(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    stroke: "#A5A5A8",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.3332 2.00001C14.6948 2.45032 13.9879 2.79474 13.2398 3.02001C12.8383 2.55835 12.3047 2.23113 11.7112 2.08262C11.1177 1.93411 10.4928 1.97147 9.92123 2.18964C9.34962 2.40781 8.8588 2.79627 8.51516 3.30248C8.17152 3.80869 7.99164 4.40823 7.99984 5.02001V5.68667C6.82826 5.71705 5.66735 5.45721 4.62051 4.9303C3.57367 4.40339 2.67338 3.62576 1.99984 2.66667C1.99984 2.66667 -0.66683 8.66667 5.33317 11.3333C3.96019 12.2653 2.32461 12.7326 0.666504 12.6667C6.6665 16 13.9998 12.6667 13.9998 5.00001C13.9992 4.81431 13.9814 4.62907 13.9465 4.44667C14.6269 3.77567 15.1071 2.92848 15.3332 2.00001Z",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTwitter);
export default __webpack_public_path__ + "static/media/twitter.e0b610c57bec12b5400f655e36fd68c4.svg";
export { ForwardRef as ReactComponent };